import { delay } from 'lodash-es';

import { PreValueApplicator } from './lodash-decorators/applicators/PreValueApplicator';
import { DecoratorConfig, DecoratorFactory, LodashMethodDecorator } from './lodash-decorators/factory';

const decorator = DecoratorFactory.createDecorator(
  new DecoratorConfig(
    // eslint-disable-next-line
    function (value: Function, wait: number, ...args: any[]) {
      // eslint-disable-next-line
      return function (...invokeArgs: any[]): any {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        return delay(value.bind(this), wait, ...invokeArgs, ...args);
      };
    },
    new PreValueApplicator(),
    { setter: true },
  ),
);

/**
 * Invokes func after wait milliseconds. Any additional arguments are provided to func when it's invoked.
 *
 * @param wait The number of milliseconds to delay invocation.
 * @param [args] Additional arguments to invoke the function with
 * @example
 *
 * class MyClass {
 *   value = 100;
 *
 *   @Delay(20)
 *   add(a) {
 *     this.value += a;
 *   }
 * }
 *
 * const myClass = new MyClass();
 *
 * myClass.add(10);
 *
 * myClass.value; // => 100;
 *
 * setTimeout(() => {
 *   myClass.value; // => 110;
 * }, 30);
 */
export function Delay(wait: number, ...args: any[]): LodashMethodDecorator {
  return decorator(wait, ...args);
}

export { Delay as delay };
export default decorator;
